"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var _require = require("./utils.js"),
  removeLeadingAndTrailingHTTPWhitespace = _require.removeLeadingAndTrailingHTTPWhitespace,
  removeTrailingHTTPWhitespace = _require.removeTrailingHTTPWhitespace,
  isHTTPWhitespaceChar = _require.isHTTPWhitespaceChar,
  solelyContainsHTTPTokenCodePoints = _require.solelyContainsHTTPTokenCodePoints,
  soleyContainsHTTPQuotedStringTokenCodePoints = _require.soleyContainsHTTPQuotedStringTokenCodePoints,
  asciiLowercase = _require.asciiLowercase,
  collectAnHTTPQuotedString = _require.collectAnHTTPQuotedString;
module.exports = function (input) {
  input = removeLeadingAndTrailingHTTPWhitespace(input);
  var position = 0;
  var type = "";
  while (position < input.length && input[position] !== "/") {
    type += input[position];
    ++position;
  }
  if (type.length === 0 || !solelyContainsHTTPTokenCodePoints(type)) {
    return null;
  }
  if (position >= input.length) {
    return null;
  }

  // Skips past "/"
  ++position;
  var subtype = "";
  while (position < input.length && input[position] !== ";") {
    subtype += input[position];
    ++position;
  }
  subtype = removeTrailingHTTPWhitespace(subtype);
  if (subtype.length === 0 || !solelyContainsHTTPTokenCodePoints(subtype)) {
    return null;
  }
  var mimeType = {
    type: asciiLowercase(type),
    subtype: asciiLowercase(subtype),
    parameters: new Map()
  };
  while (position < input.length) {
    // Skip past ";"
    ++position;
    while (isHTTPWhitespaceChar(input[position])) {
      ++position;
    }
    var parameterName = "";
    while (position < input.length && input[position] !== ";" && input[position] !== "=") {
      parameterName += input[position];
      ++position;
    }
    parameterName = asciiLowercase(parameterName);
    if (position < input.length) {
      if (input[position] === ";") {
        continue;
      }

      // Skip past "="
      ++position;
    }
    var parameterValue = null;
    if (input[position] === "\"") {
      var _collectAnHTTPQuotedS = collectAnHTTPQuotedString(input, position);
      var _collectAnHTTPQuotedS2 = _slicedToArray(_collectAnHTTPQuotedS, 2);
      parameterValue = _collectAnHTTPQuotedS2[0];
      position = _collectAnHTTPQuotedS2[1];
      while (position < input.length && input[position] !== ";") {
        ++position;
      }
    } else {
      parameterValue = "";
      while (position < input.length && input[position] !== ";") {
        parameterValue += input[position];
        ++position;
      }
      parameterValue = removeTrailingHTTPWhitespace(parameterValue);
      if (parameterValue === "") {
        continue;
      }
    }
    if (parameterName.length > 0 && solelyContainsHTTPTokenCodePoints(parameterName) && soleyContainsHTTPQuotedStringTokenCodePoints(parameterValue) && !mimeType.parameters.has(parameterName)) {
      mimeType.parameters.set(parameterName, parameterValue);
    }
  }
  return mimeType;
};